import types from '../../constants';


export function cleanLog() {
  return async (dispatch) => {
    dispatch({ type: types.LOGGER_CLEAN_LOG });
  };
}
